<div id="activities" class="page-layout simple left-sidebar inner-sidebar inner-scroll w-full">
  <!-- [ngClass]="class == true ? 'height-836' : 'height-835'" -->
  <h3 style="margin-bottom: 0px; padding: 15px 15px 0 15px" class="text-[14px]">
    <b>
      Do you charge a fixed price for certain types of work (Eg Preparation of Will) or for
      sundries?
    </b>
    <br />
    <br />
    Just pre-define them here so they are ready for you to use in the Billing system.
  </h3>
  <br />
  <div class="border-line"></div>
  <br />
  <div class="content" fxLayoutAlign="center">
    <div class="center more_tbl_clmn list_tbl_main w-full">
      <div class="matter-serach-div sticky_search_div responsive_auto">
        <form [formGroup]="activitiesFilter" class="justify-content-between flex items-center">
          <div class="flex items-center">
            <mat-form-field class="example" appearance="outline" fxFlex="30">
              <mat-label>Type</mat-label>
              <mat-select
                #value
                name="selected"
                (selectionChange)="TypeChange($event)"
                formControlName="TYPE"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="Activities">Activities</mat-option>
                <mat-option value="Sundries">Sundries</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              mat-raised-button
              type="button"
              color="primary"
              id="refreshActivities"
              (click)="refreshActivities()"
            >
              Refresh
            </button>
            <mat-checkbox formControlName="HighlightItem" (change)="HighlightChange($event)">
              Highlight Item
            </mat-checkbox>
          </div>
          <div>
            <button
              mat-flat-button
              color="accent"
              [ngClass]="
                appPermissions?.[30]?.Create == 0 ? 'disabled-click large-button' : 'large-button'
              "
              class="mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
              (click)="addActivities()"
            >
              <mat-icon class="fs-21">add</mat-icon>
              Add
            </button>
            <button
              mat-flat-button
              color="accent"
              [ngClass]="
                appPermissions?.[30]?.Create == 0 || isActivityData == 'empty'
                  ? 'disabled-click large-button'
                  : 'large-button'
              "
              class="mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
              (click)="addDuplicateActivities('Duplicate')"
            >
              <mat-icon class="fs-21">file_copy</mat-icon>
              Duplicate
            </button>
          </div>
          <span class="appCues-blankSpace">
            <a href="javascript:void(0);">Link</a>
          </span>
        </form>
      </div>
      <div class="content">
        <div class="page-layout simple left-sidebar inner-sidebar">
          <div>
            <div class="center more_tbl_clmn">
              <div class="content">
                <div class="btn top_right_action_billing_position">
                  <button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="More">
                    <mat-icon class="secondary-text">more_vert</mat-icon>
                  </button>
                  <mat-menu #contextMenu="matMenu">
                    <ng-template matMenuContent let-item="item">
                      <button mat-menu-item (click)="openDialog()">Field Configuration</button>
                      <button mat-menu-item (click)="refreshActivities()">Reload Data</button>
                    </ng-template>
                  </mat-menu>
                </div>
                <div class="content">
                  @if (isLoadingResults) {
                    <div class="example-loading-shade">
                      <mat-spinner [style.zoom]="1"></mat-spinner>
                    </div>
                  }
                  <div
                    class="example-containerdata resizable-table"
                    [ngClass]="class == true ? 'activity-table-2' : 'activity-table'"
                  >
                    @if (isDisplay && !addNewActivities) {
                      <div class="grid-overlay">
                        <div class="grid-overlay-msg">There is no data to display.</div>
                      </div>
                    }
                    <table
                      mat-table
                      #table
                      [dataSource]="Activitiesdata"
                      (matSortChange)="sortData($event)"
                      matSortActive="{{ sortactive }}"
                      matSortDirection="{{ sortDirection }}"
                      multiTemplateDataRows
                      matSortDisableClear
                      matSort
                      [@animateStagger]="{ value: '50' }"
                    >
                      @for (item of displayedColumns; track item) {
                        <ng-container [matColumnDef]="item">
                          @if (item === 'Expand') {
                            <th mat-header-cell *matHeaderCellDef class="header_title"></th>
                            <td
                              mat-cell
                              *matCellDef="let element; let i = dataIndex"
                              class="dropdown-btn"
                            >
                              <button
                                matIconButton
                                type="button"
                                [ngClass]="
                                  appPermissions?.[30]?.Edit == 0 || isActivityData == 'empty'
                                    ? 'disabled-click large-button'
                                    : 'large-button'
                                "
                                (click)="editModeExpand(element, i); $event.stopPropagation()"
                                class="spend-money-dropdown flex items-center border border-black/12 text-black"
                              >
                                <mat-icon class="items-center justify-center text-2xl">
                                  {{ !element.EXPEND ? 'edit' : 'keyboard_arrow_down' }}
                                </mat-icon>
                              </button>
                            </td>
                          } @else {
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              mat-sort-header
                              class="header_title"
                              mwlResizable
                              [enableGhostResize]="false"
                              (resizing)="onResizing($event, item)"
                              (resizeEnd)="onResizeEnd($event, item)"
                              [resizeEdges]="{
                                bottom: false,
                                right: true,
                                top: false,
                                left: true,
                              }"
                            >
                              <div
                                class="desc_cell resize-handle-right"
                                mwlResizeHandle
                                [resizeEdges]="{ right: true }"
                                (mousedown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()"
                              ></div>
                              {{
                                tempColobj[item]?.DESCRIPTION ? tempColobj[item].DESCRIPTION : ' '
                              }}
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let row"
                              class="text-{{ tempColobj[item].JUSTIFICATION }}-align mat-column-{{
                                item
                              }}"
                              [ngClass]="{
                                'word-wrap-class': tempColobj[item].WIDEDATA,
                              }"
                            >
                              @if (
                                row[item] &&
                                item != 'GSTTYPE' &&
                                item != 'ACTIVITYTYPE' &&
                                row[item] !== undefined
                              ) {
                                <span>
                                  {{
                                    row[item]
                                      | toFixedAmount: tempColobj[item].CURRENCY
                                      | wordwrap: tempColobj[item].WIDEDATA
                                  }}
                                </span>
                              }
                              @if (item == 'GSTTYPE') {
                                <span>{{ row.GSTTYPEDESC }}</span>
                              }
                              @if (item == 'ACTIVITYTYPE') {
                                <span>
                                  {{ row.ACTIVITYTYPEDESC }}
                                </span>
                              }
                            </td>
                          }
                        </ng-container>
                      }

                      <ng-container matColumnDef="header-row-first-group">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          [style.text-align]="'center'"
                          [attr.colspan]="displayedColumns?.length"
                          class="activity-add-header-cell"
                        >
                          <ng-container
                            *ngTemplateOutlet="activityFormPanel; context: { formMode: 'insert' }"
                          ></ng-container>
                        </th>
                      </ng-container>

                      <ng-container matColumnDef="secondary">
                        <td
                          mat-cell
                          *matCellDef="let element"
                          [attr.colspan]="displayedColumns?.length"
                          class="activity-detail-cell"
                        >
                          @if (element?.EXPEND) {
                            <ng-container
                              *ngTemplateOutlet="
                                activityFormPanel;
                                context: { formMode: modeTypeIs }
                              "
                            ></ng-container>
                          }
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="['header-row-first-group']"
                        [ngClass]="addNewActivities ? 'activity-add-header-row' : 'hideRow'"
                      ></tr>

                      <tr
                        mat-row
                        [style.background]="
                          highlightedRows == row.ACTIVITYGUID ? selectedColore : ''
                        "
                        *matRowDef="let row; columns: displayedColumns"
                        [ngClass]="highlightedRows == row.ACTIVITYGUID ? 'row-text-colore' : ''"
                        class="contact"
                        (click)="
                          setActiveData(row);
                          currentActivitieData = row;
                          highlightedRows = row.ACTIVITYGUID
                        "
                        [@animate]="{ value: '*', params: { y: '100%' } }"
                      ></tr>

                      <tr
                        mat-row
                        *matRowDef="let row; columns: ['secondary']"
                        [ngClass]="row?.EXPEND ? 'activity-detail-row' : 'hideRow'"
                      ></tr>

                      <ng-template #activityFormPanel let-formMode="formMode">
                        <div class="activities-main">
                          <div mat-dialog-content class="mat-typography main">
                            <div
                              class="one activities-block"
                              fxLayout="column"
                              fxLayoutAlign="start"
                              fxLayout.gt-md="row"
                            >
                              <form
                                [formGroup]="activityForm"
                                fxLayout="column"
                                fxFlexfill
                                name="form"
                              >
                                <div fxLayout="row" fxLayoutAlign="start center" fxFlexfill>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="20"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.ACTIVITYTYPE
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.ACTIVITYTYPE
                                      ),
                                    }"
                                  >
                                    <mat-label>Activity Type</mat-label>
                                    <mat-select formControlName="ACTIVITYTYPE">
                                      <mat-option value="Activity">Fixed Fee</mat-option>
                                      <mat-option value="Sundry">Sundry</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="20"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.ACTIVITYID
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.ACTIVITYID
                                      ),
                                    }"
                                  >
                                    <mat-label>Sundry / Fixed Fee</mat-label>
                                    <input
                                      formControlName="ACTIVITYID"
                                      matInput
                                      #activityIdInput
                                      (input)="
                                        activityIdInput.value = $event.target.value.toUpperCase()
                                      "
                                      [matTooltip]="
                                        toolTipList
                                          ? $safeNavigationMigration(toolTipList?.ACTIVITYID?.HOVER)
                                          : ''
                                      "
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="60"
                                    class="full-width pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.DESCRIPTION
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.DESCRIPTION
                                      ),
                                    }"
                                  >
                                    <mat-label>Description</mat-label>
                                    <textarea
                                      matInput
                                      formControlName="DESCRIPTION"
                                      rows="2"
                                      (keydown.enter)="$event.stopImmediatePropagation()"
                                      [matTooltip]="
                                        toolTipList
                                          ? $safeNavigationMigration(
                                              toolTipList?.DESCRIPTION?.HOVER
                                            )
                                          : ''
                                      "
                                      [matTooltipPosition]="toolTipPostion"
                                    ></textarea>
                                  </mat-form-field>
                                </div>
                                <div
                                  fxLayout="row"
                                  fxLayoutAlign="start center"
                                  fxFlexfill
                                  class="activities-block activity-wrap"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="18"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.GSTTYPE
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.GSTTYPE
                                      ),
                                    }"
                                  >
                                    <mat-label>GST Type</mat-label>
                                    <mat-select formControlName="GSTTYPE">
                                      <mat-option value="GST Exclusive">GST Exclusive</mat-option>
                                      <mat-option value="GST Inclusive">GST Inclusive</mat-option>
                                      <mat-option value="GST Free">GST Free</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="18"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.RATEPERUNIT
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.RATEPERUNIT
                                      ),
                                    }"
                                  >
                                    <mat-label>
                                      {{ CurrenctSymbol }}
                                      /Unit
                                    </mat-label>
                                    <input
                                      style="text-align: right"
                                      type="text"
                                      mask="separator.2"
                                      thousandSeparator=","
                                      [allowNegativeNumbers]="true"
                                      decimalMarker="."
                                      formControlName="RATEPERUNIT"
                                      class="sideText"
                                      matInput
                                      [leadZero]="true"
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="18"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.UNITDESCRIPTIONSINGLE
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.UNITDESCRIPTIONSINGLE
                                      ),
                                    }"
                                  >
                                    <mat-label>Unit Desc Single</mat-label>
                                    <input
                                      type="text"
                                      matInput
                                      formControlName="UNITDESCRIPTIONSINGLE"
                                      [matAutocomplete]="unitSingleAuto"
                                      [matTooltip]="
                                        toolTipList
                                          ? $safeNavigationMigration(
                                              toolTipList?.UNITDESCRIPTIONSINGLE?.HOVER
                                            )
                                          : ''
                                      "
                                    />
                                    <mat-autocomplete #unitSingleAuto="matAutocomplete">
                                      <mat-option value="unit">Unit</mat-option>
                                      <mat-option value="page">Page</mat-option>
                                      <mat-option value="item">Item</mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    fxFlex="18"
                                    class="pr-1"
                                    [ngClass]="{
                                      'has-error': $safeNavigationMigration(
                                        errorWarningData.Error?.UNITDESCRIPTIONPLURAL
                                      ),
                                      'has-warning': $safeNavigationMigration(
                                        errorWarningData.Warning?.UNITDESCRIPTIONPLURAL
                                      ),
                                    }"
                                  >
                                    <mat-label>Unit Desc Plural</mat-label>
                                    <input
                                      type="text"
                                      matInput
                                      formControlName="UNITDESCRIPTIONPLURAL"
                                      [matAutocomplete]="unitPluralAuto"
                                      [matTooltip]="
                                        toolTipList
                                          ? $safeNavigationMigration(
                                              toolTipList?.UNITDESCRIPTIONPLURAL?.HOVER
                                            )
                                          : ''
                                      "
                                    />
                                    <mat-autocomplete #unitPluralAuto="matAutocomplete">
                                      <mat-option value="units">Units</mat-option>
                                      <mat-option value="pages">Pages</mat-option>
                                      <mat-option value="items">Items</mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                  <mat-checkbox formControlName="HIGHLIGHTITEM" class="paddingb-12">
                                    Highlight Item
                                  </mat-checkbox>
                                </div>
                              </form>
                            </div>
                            <hr />
                            <div
                              class="activity-buttons flex items-center justify-start"
                              [ngClass]="formMode === 'edit' ? 'flex' : 'justify-content-right'"
                            >
                              @if (formMode === 'insert') {
                                <button
                                  mat-button
                                  color="warn"
                                  class="activity-drop-button text-red-500!"
                                  (click)="cancle()"
                                >
                                  Cancel
                                </button>
                                <button
                                  matButton="filled"
                                  color="primary"
                                  class="activity-drop-button ml-8"
                                  (click)="saveActivity()"
                                >
                                  Add
                                </button>
                              }
                              @if (formMode === 'edit') {
                                <button
                                  mat-button
                                  color="warn"
                                  class="activity-drop-button text-red-500!"
                                  (click)="DeleteActivityDialog()"
                                  [ngClass]="
                                    appPermissions?.[30]?.Delete == 0 || isActivityData == 'empty'
                                      ? 'disabled-click large-button'
                                      : 'large-button'
                                  "
                                >
                                  Delete
                                </button>
                                <button
                                  matButton="filled"
                                  color="primary"
                                  class="activity-drop-button ml-8"
                                  (click)="saveActivity()"
                                >
                                  Update
                                </button>
                              }
                              @if (formMode === 'Duplicate') {
                                <button
                                  mat-button
                                  color="warn"
                                  class="activity-drop-button text-red-500!"
                                  (click)="cancelDuplicate()"
                                >
                                  Cancel
                                </button>
                                <button
                                  matButton="filled"
                                  color="primary"
                                  class="activity-drop-button ml-8"
                                  (click)="saveActivity()"
                                >
                                  Duplicate
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </table>
                  </div>
                  <mat-paginator
                    [pageSizeOptions]="[10, 20, 50, 100]"
                    [pageSize]="$safeNavigationMigration(pageSize?.activities)"
                    (page)="onPaginateChange($event)"
                    showFirstLastButtons
                  ></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
